import { Check } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EntitySidecar } from '@/services/api/generated/partiesService';

interface ApproveFieldButtonProps {
  fieldKey: string;
  approvalMetadata?: EntitySidecar | null;
  onApprove: (fieldKey: string) => void;
  disabled?: boolean;
  compact?: boolean;
}

export const ApproveFieldButton = ({
  fieldKey,
  approvalMetadata,
  onApprove,
  disabled,
  compact = false,
}: ApproveFieldButtonProps) => {
  const isAccepted = approvalMetadata?.field_suggestions?.some(
    (fs) => fs.field_key === fieldKey,
  );

  if (isAccepted) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-green-600">
        <Check className="h-3 w-3" />
        {!compact && 'Approved'}
      </span>
    );
  }

  return (
    <Button
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        onApprove(fieldKey);
      }}
      disabled={disabled}
      className="h-6 px-2 text-xs"
      variant="ghost"
    >
      <Check className="h-3 w-3" />
      {!compact && 'Approve'}
    </Button>
  );
};
